import Http from 'axios'
import { resolveFileContentType } from '~/utils/fileType'

export const actions = {
	async upload(
		{ commit, dispatch },
		{ file, endpoint, field = 'file', onProgress, options = {} }
	) {
		const extraPayload = options.payload || {}
		const requestOptions = options.timeout
			? { timeout: options.timeout }
			: {}

		// Some browsers/OS pickers leave file.type empty; fall back to the
		// file extension so both requests below carry a usable content type.
		const contentType = options.contentType || resolveFileContentType(file)

		// DEV: direct file upload
		if (process.env.NODE_ENV === 'development') {
			const formData = new FormData()

			formData.append(field, file)

			Object.keys(extraPayload).forEach(key => {
				if (
					typeof extraPayload[key] !== 'undefined' &&
					extraPayload[key] !== null
				) {
					formData.append(key, extraPayload[key])
				}
			})

			return this.$axios.$post(endpoint, formData, {
				...requestOptions,
				onUploadProgress: event => {
					if (onProgress) {
						onProgress((event.loaded / event.total) * 100)
					}
				}
			})
		}

		// PRODUCTION: Vapor upload
		const data = await this.$axios.$post(
			'vapor/signed-storage-url',
			{
				bucket: options.bucket || '',
				content_type: contentType,
				expires: options.expires || '',
				visibility: options.visibility || ''
			},
			requestOptions
		)

		let headers = data.headers

		if ('Host' in headers) {
			delete headers.Host
		}

		if (typeof onProgress === 'undefined' || onProgress === null) {
			onProgress = () => {}
		}

		try {
			await Http.put(data.url, file, {
				...requestOptions,
				headers: headers,
				onUploadProgress: progressEvent => {
					onProgress(
						(progressEvent.loaded / progressEvent.total) * 100
					)
				}
			})
		} catch (error) {
			dispatch(
				'toast/push',
				{
					title: this.app.i18n.t('error.upload-failed.title'),
					message: this.app.i18n.t('error.upload-failed.message'),
					type: 'danger'
				},
				{ root: true }
			)

			error.__uploadErrorReported = true
			throw error
		}

		data.extension = file.name.split('.').pop()

		return this.$axios.$post(
			endpoint,
			{
				uuid: data.uuid,
				key: data.key,
				bucket: data.bucket,
				name: file.name,
				content_type: contentType,
				...extraPayload
			},
			requestOptions
		)
	}
}
